import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { ConfigPedidoPedidosSazonais } from 'pages/compra/configuracao-pedido/types';

export function useQueryPedidosSazonais() {
    const { id } = useParams();
    const requestListagem = useRequestListagem();

    return useQuery<ConfigPedidoPedidosSazonais>({
        queryKey: ['config-pedido-pedidos-sazonais', id],
        queryFn: () =>
            requestListagem({
                url: `/gestao/lojametaatingida/configpedido/${id}`,
            }).then((res) => res.data),
    });
}
